@if (transaction()) {
  <!-- SUMMARY -->
  <div id="cart-summary" class="bg-white rounded-2xl shadow-lg py-5">
    <div class="border-b border-gray-100 pb-2">
      <h5 class="text-xl font-bold text-[#E2383F] px-5">Cart Summary</h5>
      <small class="text-gray-400 text-base px-5"
        >Here you can see your new requested tickets</small
      >
    </div>

    <div class="px-10 py-5 border-b border-gray-100">
      <div class="flex items-center justify-end">
        <h5 class="font-bold">Seats</h5>
        <div class="ml-10">
          <h5
            class="bg-[#F2F6FA] p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
            +
            @if (transaction().transaction.tdcTransaction?.totalPriceSeats) {
              ${{
                transaction().transaction.tdcTransaction?.totalPriceSeats
                  | number: '1.2-2'
              }}
            }
          </h5>
        </div>
      </div>

      @if (isTicketFeeEnabled()) {
        @for (serviceCharge of serviceChargesDetails; track $index) {
          @if (serviceCharge.amount) {
            <div class="flex items-center justify-end mt-4">
              <h5 class="font-bold">{{ serviceCharge.name }}:</h5>
              <div class="ml-10">
                <h5
                  class="bg-[#F0F8EE] p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
                  + ${{ serviceCharge.amount | number: '1.2-2' }}
                </h5>
              </div>
            </div>
          }
        }
      } @else {
        @if (transaction().transaction.tdcTransaction?.serviceCharges) {
          <div class="flex items-center justify-end">
            <h5 class="font-bold">Total ticket fees:</h5>
            <div class="ml-10">
              <h5
                class="bg-[#F0F8EE] p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
                + ${{
                  transaction().transaction.tdcTransaction?.serviceCharges
                    | number: '1.2-2'
                }}
              </h5>
            </div>
          </div>
        }
      }

      @if (
        rainoutValue() &&
        transaction().transaction.tdcTransaction?.insuranceRainoutPrice
      ) {
        <div class="flex items-center justify-end mt-4">
          <h5 class="flex justify-end">
            <span class="mr-1 font-normal">Insurance:</span
            ><strong>Rainout Insurance:</strong>
          </h5>
          <div class="ml-10">
            <h5
              class="bg-[#F0F8EE] p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
              + ${{
                transaction().transaction.tdcTransaction
                  ?.insuranceRainoutPrice || 0 | number: '1.2-2'
              }}
            </h5>
          </div>
        </div>
      }
    </div>

    @if (upsellSelected()) {
      <div class="px-10 py-5 border-b border-gray-100">
        <div class="flex items-center justify-end">
          <h5 class="flex justify-end">
            <span class="mr-1 font-normal"
              >By purchasing tickets you receive:</span
            >
            <strong>{{ upsellSelected()?.name }}</strong>
          </h5>
          <div class="ml-10">
            <h5
              class="bg-[#E2BA36] bg-opacity-15 p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
              BENEFIT
            </h5>
          </div>
        </div>
      </div>
    }

    <div class="px-10 pt-5">
      <div class="flex items-center justify-end">
        <h5 class="font-bold">Total Balance:</h5>
        <div class="ml-5">
          <h5
            class="bg-[#F0F8EE] p-2 rounded-lg text-[#8B8B8B] font-normal w-28 text-center">
            +
            @if (transaction().transaction.tdcTransaction?.balance) {
              ${{
                transaction().transaction.tdcTransaction?.balance
                  | number: '1.2-2'
              }}
            }
          </h5>
        </div>
      </div>
    </div>
  </div>
}
